// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { QuestRoute } from '../_common/api/QuestRoutes';
import Button from '../_common/form/Button';
import Title from '../_common/form/Title';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';
import Loading from '../_common/Loading';
import Modal from '../_common/Modal';
import { HamQuest } from '../../App';

const riseUp = keyframes`
    from{
        bottom: -20%;
    }
    to {
        bottom: 10%;
    }
`;

const Wrapper = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    width: 100vw;
    z-index: 1001;
    
    animation: ${riseUp};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
`

const Prompt = styled.div`
    display: flex;
    padding: 0.5em;
    background: ${({ theme }) => theme.mobile.secondary};
    color: ${({ theme }) => theme.mobile.contrast};
    justify-content: center;
    flex-direction: column;
    align-items: center;
    border-radius: 0.2rem;
    box-shadow: 1px 1px 5px 1px ${({ theme }) => theme.mobile.shadow};
`

const Row = styled.div`
    display: flex;
`

const UpdateAlert = () => {
    const {
        state: {
            active_user,
            version
        },
        getSiteConfig
    } = useGlobalState();

    const [updated, setUpdated] = useState(false)

    useEffect(() => {
        console.log('Checking for Updates.')
        HamQuest.get(QuestRoute.appVersion)
            .then(res => setUpdated(res !== version))

        getSiteConfig();
    }, [active_user.account])

    if (!updated) return null;

    return (
        <Wrapper>
            <Prompt>
                <Title>Update available!</Title>
                <Row>
                    <Button
                        icon='reload'
                        onClick={() => {
                            Modal.Promise({
                                title: 'Updating!',
                                body: 'Please wait...'
                            })
                            caches
                                .keys()
                                .then((names) => names.forEach(e => caches.delete(e)))
                                .then(() => window.location.reload(true))
                        }}
                    >
                        Update
                    </Button>
                    <Button
                        onClick={() => setUpdated(false)}
                    >
                        Dismiss
                    </Button>
                </Row>
            </Prompt>
        </Wrapper>
    )
}

export default UpdateAlert;